<template>
  <div class="admin">
    <header class="admin-head">
      <h1 class="admin-title">Admin</h1>
      <p class="admin-sub">Manage your organization's assets, sites, categories, team and subscription.</p>
    </header>

    <div class="tabbar" role="tablist">
      <button v-for="t in tabs" :key="t.id" type="button" class="tab" :class="{ active: tab === t.id }"
        role="tab" @click="tab = t.id">{{ t.title }}</button>
    </div>

    <div class="tab-body">
      <AssetTable v-if="tab === 'assets'" />
      <MarkerCategoryTable v-else-if="tab === 'marker-cats'" />
      <TagTable v-else-if="tab === 'tags'" />
      <SiteManagementTable v-else-if="tab === 'sites'" />
      <ManageAuthMemberList v-else-if="tab === 'users'" />
      <ManageSubscriptionPanel v-else-if="tab === 'subscription'" />
    </div>
  </div>
</template>

<script>
import AssetTable from '@/components/tables/AssetTable.vue';
import SiteManagementTable from '@/components/tables/SiteManagementTable.vue';
import MarkerCategoryTable from '@/components/tables/MarkerCategoryTable.vue';
import TagTable from '@/components/tables/TagTable.vue';
import ManageAuthMemberList from '@/components/list/ManageAuthMemberList.vue';
import ManageSubscriptionPanel from '@/components/ManageSubscriptionPanel.vue';

export default {
  name: 'AdminView',
  components: {
    AssetTable,
    SiteManagementTable,
    MarkerCategoryTable,
    TagTable,
    ManageAuthMemberList,
    ManageSubscriptionPanel,
  },
  data() {
    return {
      tab: 'assets',
      tabs: [
        { id: 'assets', title: 'Assets' },
        { id: 'marker-cats', title: 'Marker categories' },
        { id: 'tags', title: 'Tags' },
        { id: 'sites', title: 'Sites' },
        { id: 'users', title: 'Users' },
        { id: 'subscription', title: 'Subscription' },
      ],
    };
  },
  mounted() {
    // Deep-link support: /admin?tab=<id> (also accepts the legacy ?menu=<id>).
    const requested = this.$route?.query?.tab || this.$route?.query?.menu;
    if (requested && this.tabs.some(t => t.id === String(requested))) {
      this.tab = String(requested);
    }
  },
};
</script>

<style scoped>
.admin {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  user-select: none;
}

.admin-head { margin-bottom: 18px; }
.admin-title { font-size: clamp(1.5rem, calc(12px + 1vw), 1.9rem); font-weight: 800; color: #fff; margin: 0; }
.admin-sub { margin: 6px 0 0; font-size: 0.92rem; color: #8aa0aa; }

.tabbar {
  display: flex; gap: 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  margin-bottom: 22px;
  overflow-x: auto;
  scrollbar-width: none;
}
.tabbar::-webkit-scrollbar { display: none; }
.tab {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 10px 4px; margin: 0 12px -1px 0;
  background: none; border: none; border-bottom: 2px solid transparent;
  color: #8aa0aa; font: inherit; font-size: 0.92rem; font-weight: 600; cursor: pointer;
  white-space: nowrap;
  transition: color 0.15s ease, border-color 0.15s ease;
}
.tab:hover:not(.active) { color: #cfd8dc; }
.tab.active { color: #fff; border-bottom-color: var(--duallo-accent); }

.tab-body { flex: 1 1 auto; min-width: 0; min-height: 0; }
</style>
